import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb42043"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chr-roadmap",
  class: "tw-flex tw-flex-col tw-items-starttw-self-stretch tw-bg-[#ffffff]"
}
const _hoisted_2 = { class: "!tw-break-inside-avoid" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-w-[100%] tw-pb-[12px]" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-flex-1" }
const _hoisted_5 = {
  id: "chr-sheading-roadmap",
  class: "tw-w-fit tw-flex tw-items-center tw-justify-center"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-h-[44px] tw-mr-[20px] tw-relative tw-flex tw-items-center tw-flex-wrap"
}
const _hoisted_7 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-normal lg:tw-w-[50%] tw-pb-[40px] tw-opacity-[0.7]" }

import { getComponentUiText } from "@/utils/utilities";
import { Ref, computed, ref, watch } from "vue";
import RoadmapTable from "./roadmapTable.vue";
import store from "@/store";
import Pen from "../svgs/pen.vue";
import { Checklist } from "@/services/apiRoutes/routes";
import TextInputWithArrow from "@/components/share/textInputWithArrow.vue";
import { localStorageKey } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'roadmap',
  props: {
  isEdit: {
    type: Boolean,
    default: false,
  },
  isEnableEdit: {
    type: Boolean,
    default: true,
  },
  rootChecklistReportId: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:edit"],
  setup(__props, { emit }) {

const props = __props;





const paging: Ref<number> = ref(5);
const maxPaging = computed(() => {
  const data = store.getters["Sharing/getChecklistRoadMap"];
  return data && data.length ? data.length : 0;
});

const handleArrowClick = ({ value }) => {
  paging.value = value;

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0) return;

  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingRoadmap) || "{}",
  );

  localData[props.rootChecklistReportId] = value;

  localStorage.setItem(
    localStorageKey.sharingPagingRoadmap,
    JSON.stringify(localData),
  );
};

const getPagingValue = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingRoadmap) || "{}",
  );

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0)
    return maxPaging.value;

  if (localData[props.rootChecklistReportId]) {
    const value = Number(localData[props.rootChecklistReportId]);
    return value > maxPaging.value ? maxPaging.value : value;
  }

  return maxPaging.value;
};

watch(
  () => maxPaging.value,
  (newVal) => {
    maxPaging.value && (paging.value = getPagingValue());
  },
);

const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistRoadMap"];
  if (!paging.value || typeof paging.value !== "number") return [];
  return !paging.value ? data : data.slice(0, Number(paging.value) || 5);
});

const isLoading: Ref<any> = computed(() => {
  return store.state.Sharing.loadingSplit[
    Checklist.getChecklistReportDataActions
  ];
});

const editNotes = () => {
  emit("update:edit", !props.isEdit);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-share-cyber-profile-roadmap-title-1")), 1)
        ]),
        (customTableData.value?.length > 0 && __props.isEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(TextInputWithArrow, {
                max: maxPaging.value,
                paging: paging.value || maxPaging.value || 5,
                type: _unref(localStorageKey).sharingPagingRoadmap,
                "custom-input-class": 'tw-text-[14px]',
                onArrowClick: handleArrowClick
              }, null, 8, ["max", "paging", "type"])
            ]))
          : _createCommentVNode("", true),
        (__props.isEnableEdit)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "pen-icon-traffic",
              class: _normalizeClass([__props.isEdit ? 'tw-bg-[#211F58]' : 'tw-bg-[#FFF]', "header__pen tw-cursor-pointer"]),
              onClick: editNotes
            }, [
              _createVNode(Pen, {
                color: __props.isEdit ? '#ffffff' : '#387DFF'
              }, null, 8, ["color"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-rshare-cyber-profile-roadmap-sub-title-1")), 1)
    ]),
    _createVNode(RoadmapTable, {
      data: customTableData.value,
      "is-loading": isLoading.value,
      "is-edit-status": __props.isEdit,
      onEditNotes: editNotes
    }, null, 8, ["data", "is-loading", "is-edit-status"])
  ]))
}
}

})